// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vj-8";
export var editMode = "_vj-3";
export var headerRow = "_vj-a";
export var headerTitle = "_vj-b";
export var product = "_vj-1";
export var productDetails = "_vj-5";
export var productDivider = "_vj-7";
export var productImage = "_vj-2";
export var productInfo = "_vj-4";
export var productTitle = "_vj-6";
export var strikethrough = "_vj-9";
export var upsellProductsCard = "_vj-0";